/**
 * Created by Josef Jurca on 5.6.2017.
 */

import {
    ActionTypes,
    DeviceStates
} from 'store/actions/widgets/player';

const defaultState = {
    deviceState: DeviceStates.UNVERIFIED
};

/**
 * Sets the player properties.
 *
 * @param {Object} state - Current state.
 * @param {Object} playerProps - Player properties.
 * @returns {Object} New state.
 */
function setPlayer (state, playerProps) {

    return {
        ...state,
        ...playerProps,
        noRedirects: !!playerProps.noRedirects
    };
}

/**
 * Sets the minimized state.
 *
 * @param {Object} state - Current state.
 * @param {Object} minimized - Minimized state.
 * @returns {Object} New state.
 */
function setMimimized (state, minimized) {

    return {
        ...state,
        minimized
    };
}

/**
 * Sets the device state.
 *
 * @param {Object} state - Current state.
 * @param {string} deviceState - Device state.
 * @returns {Object} New state.
 */
function setDeviceState (state, deviceState) {

    return {
        ...state,
        deviceState
    };
}

/**
 * Returns the player state.
 *
 * @param {Object} state - Current state.
 * @param {Object} action - Action object.
 * @returns {Object} State.
 */
export default function player (state = defaultState, action) {

    switch (action.type) {

        case ActionTypes.SET_PLAYER:
            return setPlayer(state, action.player);

        case ActionTypes.MINIMIZE_PLAYER:
            return setMimimized(state, action.minimize);

        case ActionTypes.SET_DEVICE_STATE:
            return setDeviceState(state, action.state);

        default:
            return state;
    }

}


// WEBPACK FOOTER //
// ./src/js/store/reducers/widgets/player.js